export default __webpack_public_path__ + "static/media/logo.50c95da9.svg";